import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/faqs';

export default function FaqSection() {
  const homeFaqs = faqs.slice(0, 5).map((item) => ({
    id: item.id,
    question: item.question,
    answer: item.answer,
  }));

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="FAQ"
            title="大家最常问的几个问题"
            desc="整理了入口、判断与使用三类高频疑问，读完基本能解决大部分困惑。"
          />
          <Link
            to="/faq"
            className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md border border-foreground-950 text-foreground-950 text-sm font-medium hover:bg-foreground-950 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部常见问题
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="lg:col-span-8">
          <FaqAccordion items={homeFaqs} />
        </div>
      </div>
    </section>
  );
}